<template>
	<div id="conponentAlipayIsv">
		<el-dialog title="支付宝发薪管理" 
			:visible.sync="innerVisible" 
			width="960px" 
			destroy-on-close 
			:close-on-click-modal="false" 
			:close-on-press-escape="false"
			@open="getAlipayList('cover')"
			@close="closeDialog">
			<div v-loading="alipayLoading">
				<div style="margin-bottom: 18px;">
					<div>
						<el-button type="primary" size="small" @click="getAilpaySignLink()">获取发薪签约二维码</el-button>
						<el-button type="primary" size="small" @click="getAlipayList()">刷新列表</el-button>
					</div>
					<el-alert
						style="margin-top: 10px;"
						:closable="false"
					    title="请提前引导客户完成企业支付宝注册,非企业支付宝账号签约会导致出资异常!!!"
						show-icon
					    type="warning">
					</el-alert>
				</div>
				<el-table :key="Math.random()" :data="alipayList" border :header-cell-style="{ background: '#fafafa', color: '#000' }">
					<el-table-column label="主体名称" prop="company_name" align="center"/>
					<el-table-column label="协议号" prop="agreement_no" align="center" width="200"/>
					<el-table-column label="进件情况" prop="status" align="center" width="120">
						<template slot-scope="scope">
							<template v-if="scope.row.status=='NORMAL'">
								<span style="color:#1989fa;" v-if="scope.row.data_status=='VALID'">已完成</span>
								<span style="color:#E6A23C;" v-if="scope.row.data_status=='PROCESSING'">资质审核中</span>
								<span style="color:#F56C6C;" v-if="scope.row.data_status=='INVALID'">审批失败</span>
								<span style="color:#F56C6C;" v-if="scope.row.data_status=='NO_SUBMIT'||scope.row.data_status=='REVOKED'">待提交资料</span>
							</template>
							<span style="color:#F56C6C;" v-else-if="scope.row.status=='STOP'">已暂停</span>
							<span style="color:#E6A23C;" v-else>处理中</span>
						</template>
					</el-table-column>
					<el-table-column label="备注信息" align="center">
						<template slot-scope="scope">
							<template v-if="scope.row.data_status!='VALID'&&scope.row.status=='NORMAL'">
								{{scope.row.risk_review_remark}}
							</template>
							<template v-else>-</template>
						</template>
					</el-table-column>
					<el-table-column label="操作" align="center" width="120">
						<template slot-scope="scope">
							<template v-if="scope.row.status=='NORMAL'&&(scope.row.data_status=='NO_SUBMIT'||scope.row.data_status=='REVOKED'||scope.row.data_status=='INVALID')">
								<el-button type="text" @click="openData(scope.row.id)">提交资料</el-button>
							</template>
							<template v-if="scope.row.status!='NORMAL'">
								<el-button type="text" @click="closeSign(scope.row.id)">取消签约</el-button>
							</template>
							
						</template>
					</el-table-column>
				</el-table>
			</div>
			<el-dialog
				title="提交资料"
				:visible.sync="dataShow" 
				width="670px"
				destroy-on-close
				:close-on-click-modal="false" 
				:close-on-press-escape="false"
				:show-close="false"
				append-to-body>
				<div class="dataBox" v-loading="uploadLoading" element-loading-text="文件上传中，请勿关闭窗口">
					<el-form label-position="top">
						<el-form-item label="是否有发薪资质：" label-position="left">
							<el-radio v-model="uploadType" :label="1">人资企业</el-radio>
							<el-radio v-model="uploadType" :label="2">非人资企业</el-radio>
						</el-form-item>
						<template v-if="uploadType==1">
							<el-form-item label="人力资源许可证：">
								<div class="alipayUploadTips">请上传 人力资源经营许可证 | 劳务派遣经营许可证 | 委托代征协议 - （三选一）</div>
								<div class="alipayUploadBox">
									<div class="box" v-if="renzi">
										<el-image class="img" :src="createObjectURL(renzi)" fit="cover" :preview-src-list="[createObjectURL(renzi)]"></el-image>
										<i class="el-icon-error delicon" @click="renzi=''"></i>
									</div>
									<div v-else class="box" @click="$refs.uploadRenzi.click()">
										<i class="alipayUploadIcon el-icon-upload"></i>
										<div class="alipayUploadIconTips">请上传上述资质图片</div>
									</div>
								</div>
								<input class="alipayUploadInput" accept="image/*" type="file" ref="uploadRenzi" @change="uploadRenzi"/>
							</el-form-item>
							<el-form-item label="上游企业委托发薪合同：">
								<div class="alipayUploadTips">请上传文件，仅支持PDF格式</div>
								<div class="alipayUploadBox">
									<div class="box" v-for="(item,index) in contractFiles" :key="index">
										<el-image class="pdfIcon" :src="require('assets/icon-pdf.png')" fit="cover"/>
										<div class="pdfName">{{item.name}}</div>
										<i class="el-icon-error delicon" @click="delFiles('contractFiles',index)"></i>
									</div>
									<div class="box" @click="$refs.uploadPdfFile.click()" v-if="contractFiles.length<3">
										<i class="alipayUploadIcon el-icon-upload"></i>
										<div class="alipayUploadIconTips">请上传PDF格式的合同文件</div>
									</div>
								</div>
								<input class="alipayUploadInput" accept="application/pdf" type="file" ref="uploadPdfFile" @change="uploadFiles"/>
							</el-form-item>
						</template>
						<template v-if="uploadType==2">
							<el-form-item label="发薪证明：">
								<div class="alipayUploadTips">
									<div>请上传下述资质文件，仅支持PDF格式 （二选一即可）</div>
									<div>1、付款员工清单（需盖章） + 至少 3 份已签署的劳动（务）合同</div>
									<div>2、付款员工清单（需盖章） + 有权机关出具的最近一个月代缴个税证明或社保缴纳证明</div>
								</div>
								<div class="alipayUploadBox">
									<div class="box" v-for="(item,index) in otherFiles" :key="index">
										<el-image class="pdfIcon" :src="require('assets/icon-pdf.png')" fit="cover"/>
										<div class="pdfName">{{item.name}}</div>
										<i class="el-icon-error delicon" @click="delFiles('otherFiles',index)"></i>
									</div>
									<div class="box" @click="$refs.uploadOtherFile.click()" v-if="otherFiles.length<5">
										<i class="alipayUploadIcon el-icon-upload"></i>
										<div class="alipayUploadIconTips">请上传PDF格式的证明文件</div>
									</div>
								</div>
								<input class="alipayUploadInput" accept="application/pdf" type="file" ref="uploadOtherFile" @change="uploadOtherFiles"/>
							</el-form-item>
						</template>
					</el-form>
					<div style="text-align: center;margin-top: 28px;">
						<el-button type="primary" size="small" @click="dataShow=false">取消</el-button>
						<el-button type="primary" size="small" @click="sendDataInfo()">确认</el-button>
					</div>
					
				</div>
				
			</el-dialog>
		</el-dialog>
		
		<el-dialog
		    width="380px"
		    title="获取签约二维码"
		    :visible.sync="alipayResult"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			destroy-on-close>
			<el-result 
				:icon="alipaySignCode==200?'success':'error'" 
				:title="alipaySignCode==200?alipayCompany:'获取失败'" 
				:subTitle="alipaySignCode!=200?`${alipayErrMsg||'服务器错误'}`:'签约码获取成功，请引导客户使用企业支付宝扫码签约，签约完成前请勿关闭此窗口'">
			    <template slot="extra" v-if="alipaySignCode==200">
			        <el-button type="primary" size="medium" @click="openLink(alipaySign)">打开二维码</el-button>
			        <el-button type="primary" size="medium" @click="alipayBindConfirm()">已完成签约</el-button>
			    </template>
			</el-result>
		</el-dialog>
	</div>
</template>

<script>
	import {eltips,qiniuUpload} from '@/util/util.js'
	export default {
		name: "conponentAlipayIsv",
		data() {
			return {
				alipayLoading:true,
				alipayList:[],
				alipaySign:null,
				alipaySignCode:0,
				alipayErrMsg:'',
				alipayCompany:'',
				alipayResult:false,
				dataShow:false,
				renzi:null,
				contractFiles:[],
				otherFiles:[],
				uploadType:1,
				sign_id:'',
				uploadLoading:false,
			};
		},
		props:{
			visible: {
				type: Boolean,
				default: false
			},
			shopId: {
				type: [String,Number],
				default: ''
			},
		},
		computed: {
		    innerVisible: {
		      get() {
		        return this.visible;
		      },
		      set(value) {
		        this.$emit("update:visible", value);
		      },
		    },
		},
		methods:{
			closeSign(id){
				this.$confirm('取消签约后，用户签约二维码会失效，本次签约信息被删除，是否继续？', '取消签约', {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				}).then(() => {
				    this.axios.post('/api/main/Isv/close_agreement',{id:id}).then(res=>{
						if(res.code==200){
							eltips(res.msg,'success')
							this.getAlipayList()
						}else{
							eltips(res.msg,'error')
						}
					})
				}).catch(() => {});
			},
			async sendDataInfo(){
				if(this.uploadType==1&&!this.renzi) return eltips('请上传人资许可证','error')
				if(this.uploadType==1&&this.contractFiles.length==0) return eltips('请上传上游合同文件','error')
				if(this.uploadType==2&&this.otherFiles.length==0) return eltips('请上传证明文件','error')
				let data = {
					sign_id:this.sign_id
				}
				this.uploadLoading = true
				
				//获取七牛云token
				const qiniuTokenRes = await this.axios.post('/api/upload/get_qiniu_token')
				if(qiniuTokenRes.code!=200){
					eltips('上传文件失败，请稍后重试')
					this.uploadLoading = false;
					return
				}
				
				let fileArr = []
				if(this.uploadType==1){
					const renziEx =  this.getFileExtension(this.renzi.name)
					const renziKey = `apliyISV-进件资料-资质文件-${this.shopId}-${new Date().getTime()}.${renziEx}`
					const renziUrl = await qiniuUpload(this.renzi,renziKey,qiniuTokenRes.data)
					if(!renziUrl){
						eltips('上传文件失败，请稍后重试')
						this.uploadLoading = false;
						return
					}
					fileArr.push(renziUrl)
					
					for(let i=0;i<this.contractFiles.length;i++){
						const extension =  this.getFileExtension(this.contractFiles[i].name)
						const fileKey = `apliyISV-进件资料-上游合同-${this.shopId}-${new Date().getTime()}.${extension}`
						const fileUrl = await qiniuUpload(this.contractFiles[i],fileKey,qiniuTokenRes.data)
						if(!fileUrl){
							eltips('上传文件失败，请稍后重试')
							this.uploadLoading = false;
							return
						}
						fileArr.push(fileUrl)
					}
				}else{
					for(let i=0;i<this.otherFiles.length;i++){
						const extension =  this.getFileExtension(this.otherFiles[i].name)
						const fileKey = `apliyISV-进件资料-上游合同-${this.shopId}-${new Date().getTime()}.${extension}`
						const fileUrl = await qiniuUpload(this.otherFiles[i],fileKey,qiniuTokenRes.data)
						if(!fileUrl){
							eltips('上传文件失败，请稍后重试')
							this.uploadLoading = false;
							return
						}
						fileArr.push(fileUrl)
					}
				}
				
				data.scene_qualification_image = fileArr
				this.axios.post('/api/main/KYB/expandindirect_create',data).then(res=>{
					this.uploadLoading = false
					if(res.code==200){
						eltips(res.msg,'success')
						this.dataShow = false
						this.getAlipayList()
					}else{
						eltips(res.msg,'error')
					}
				})
				
			},
			delFiles(params,index){
				this[params].splice(index,1)
			},
			createObjectURL(file) {
				return URL.createObjectURL(file)
			},
			getFileExtension(filePath) {
			  const parts = filePath.split('.');
			  return parts[parts.length - 1];
			},
			uploadOtherFiles(e){
				const files = e.target.files
				const file = files[0]
				console.log(file)
				if(!file.type.includes('application/pdf')){
					eltips('请上传pdf文件','error')
					this.$refs.uploadOtherFile.value = '';
					return
				}
				this.otherFiles.push(file)
				this.$refs.uploadOtherFile.value = '';
			},
			uploadFiles(e){
				const files = e.target.files
				const file = files[0]
				console.log(file)
				if(!file.type.includes('application/pdf')){
					eltips('请上传pdf文件','error')
					this.$refs.uploadPdfFile.value = '';
					return
				}
				this.contractFiles.push(file)
				this.$refs.uploadPdfFile.value = '';
			},
			uploadRenzi(e){
				const files = e.target.files
				const imageFile = files[0]
				console.log(imageFile)
				if(!imageFile.type.includes('image/')){
					eltips('请上传图片文件','error')
					this.$refs.uploadRenzi.value = '';
					return
				}
				this.renzi = imageFile
				this.$refs.uploadRenzi.value = '';
			},
			openData(id){
				this.sign_id = id
				this.renzi = null
				this.contractFiles = []
				this.otherFiles = []
				this.uploadType = 1
				this.dataShow = true
			},
			closeDialog(){
				this.$emit('update:visible',false)
			},
			//支付宝发薪
			openLink(link){
				window.open(link,'_blank')
			},
			restAlipayCode(){
				this.alipaySignCode = 0
				this.alipayErrMsg = ''
				this.alipayCompany = ''
				this.alipaySign = null
				this.alipayResult = false
				this.alipayLoading = false
			},
			alipayBindConfirm(){
				this.$confirm('请确认用户签约已完成，此窗口关闭后将无法再次打开。', '签约已完成', {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
				    type: 'warning'
				}).then(() => {
				    this.alipayResult = false
					this.getAlipayList()
				}).catch(() => {});
			},
			getAilpaySignLink(){
				this.restAlipayCode()
				this.$prompt('用户签约前请勿重复获取签约二维码！！！', '获取签约二维码', {
				    confirmButtonText: '确定',
				    cancelButtonText: '取消',
					closeOnClickModal:false,
					inputPlaceholder:'请输入企业支付宝主体名称',
					inputValidator(value) {
						if (!value) return '主体名称不能为空'
						if (value.replace(/\s/g, '').length < 1) return '主体名称不能为空'
					}
				}).then(({ value }) => {
					const data = {
						company_name:value,
						shop_id:this.shopId
					}
				    this.alipayLoading = true
				    this.axios.post('/api/main/Isv/get_signing_link',data).then(res=>{
				    	this.alipayLoading = false
				    	this.alipaySignCode = res.code
				    	if(res.code==200){
							this.alipayCompany = data.company_name
				    		this.alipaySign = res.data
							this.getAlipayList()
				    	}else{
							this.alipayErrMsg = res.msg
				    	}
						this.alipayResult = true
				    })
				}).catch(() => {});
			},
			getAlipayList(cover){
				if(cover) this.alipayList = []
				let data = { shop_id:this.shopId }
				this.alipayLoading = true
				this.axios.get('/api/main/Isv/getIsvSignList',{params:data}).then(res=>{
					this.alipayLoading = false
					if(res.code==200){
						this.alipayList = res.data
					}else{
						eltips(res.msg,'error')
					}
				})
			},
		}
	};
</script>

<style lang="less" scoped>
	#conponentAlipayIsv{
		
	}
	
	.dataBox /deep/ .el-form-item{
		margin-bottom: 10px;
	}
	
	.dataBox /deep/ .el-form-item__label{
		font-weight: bold;
		padding-bottom: 0;
	}
	
	.alipayUploadTips{
		width: 100%;
		line-height: 22px;
		color: #666;
	}
	
	.alipayUploadBox{
		width: 100%;
		margin-top: 12px;
		display: flex;
		flex-wrap: wrap;
		gap: 12px;
		.box{
			width: 200px;
			height: 120px;
			border: 1px solid #ccc;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: center;
			border-radius: 2px;
			cursor: pointer;
			position: relative;
			.alipayUploadIcon{
				font-size: 48px;
				color: #409EFF;
			}
			.alipayUploadIconTips{
				color: #409EFF;
			}
			.img{
				width: 100%;
				height: 100%;
			}
			.delicon{
				color: #F00;
				font-size: 20px;
				position: absolute;
				top: -10px;
				right: -10px;
				background: #ffff;
				border-radius: 50%;
				cursor: pointer;
			}
			.pdfIcon{
				width: 38px;
				height: 38px;
			}
			.pdfName{
				line-height: 18px;
				margin-top: 8px;
				padding: 0 8px;
			}
		}
	}
	
	.alipayUploadInput{
		width: 0;
		height: 0;
		opacity: 0;
		display: block;
	}
</style>